import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";

const EngagementKpiCards = ({ data }) => {
    const items = [
        { label: "Total Likes", value: data?.totalLikes ?? 0 },
        { label: "Total Comments", value: data?.totalComments ?? 0 },
        { label: "Total Shares", value: data?.totalShares ?? 0 },
        { label: "Total Clicks", value: data?.totalClicks ?? 0 }
    ];

    return (
        <Grid container spacing={3}>
            {items.map((item) => (
                <Grid item xs={12} sm={6} md={3} key={item.label}>
                    <Card elevation={0} sx={{ borderRadius: 4, p: 1 }}>
                        <CardContent>
                            <Typography variant="body2" color="text.secondary">
                                {item.label}
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: 700, mt: 1 }}>
                                {item.value.toLocaleString()}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};

export default EngagementKpiCards;